import { Popover } from "antd";
import { useSelector } from "react-redux";

function PopoverMenuSolved({
  actionDataList,
  row,
  setRowValue,
  setThresholdDrawer,
  setChangeSignatoryDrawer,
  setChangeRMDrawer,
  setResendRegistrationLinkDrawer,
  setDeactivateUserDrawer,
  setResendWelcomeMailDrawer,
  setActivateUserDrawer,
  setViewUserEditDetailsDrawer,
  setPartnerViewEditUserDetailsDrawer,
  setMakePrimaryDrawer,
  setRemovePrimaryDrawer,
  setActivatePartnerUserDrawer,
  setDeactivatePartnerUserDrawer,
  setResendPartnerWelcomeMailDrawer,
  setActivatePartnerDrawer,
  setDeactivatePartnerDrawer,
  history,
  redirectRoute,
}) {
  const partnerQualification = useSelector(
    (state) =>
      state?.dashboardReducer?.dashboardDetails?.data?.dto?.qualifiedPartner
  );
  const isEmailMatch = useSelector(
    (state) =>
      state?.dashboardReducer?.dashboardDetails?.data?.dto?.loggedInEmailId
  );
  const handlePopoverOpen = (row) => {
    // This function is to check the row click
    // console.log(
    //   "Row clicked in Popover:",
    //   row.original
    // );
  };
  return (
    <div className="actionsDot">
      <Popover
        placement="bottom"
        title={""}
        content={
          <div className="actions-popover">
            <div
              onClick={() => {
                setRowValue(row);
              }}
            >
              {actionDataList?.length > 0 &&
                actionDataList?.map((item, index) => {
                  if (item.component === "ChangeThreshold")
                    return (
                      <p
                        style={{
                          cursor: "pointer",
                          color: "#00b1b1",
                        }}
                        onClick={() => setThresholdDrawer(true)}
                      >
                        Change Threshold
                      </p>
                    );
                  else if (item.component === "ChangeSignatoryUser")
                    return (
                      <p
                        style={{
                          cursor: "pointer",
                          color: "#00b1b1",
                        }}
                        onClick={() => setChangeSignatoryDrawer(true)}
                      >
                        Change Signatory User
                      </p>
                    );
                  else if (item.component === "ChangeRM")
                    return (
                      <p
                        style={{
                          cursor: "pointer",
                          color: "#00b1b1",
                        }}
                        onClick={() => setChangeRMDrawer(true)}
                      >
                        Change RM
                      </p>
                    );
                  else if (item.component === "ResendRegistrationLink")
                    return (
                      <p
                        style={{
                          cursor: "pointer",
                          color: "#00b1b1",
                        }}
                        onClick={() => setResendRegistrationLinkDrawer(true)}
                      >
                        Resend Registration Link
                      </p>
                    );
                  else if (item.component === "DeactivatePartner")
                    return (
                      <p
                        style={{
                          cursor: "pointer",
                          color: "#00b1b1",
                        }}
                        onClick={() => setDeactivatePartnerDrawer(true)}
                      >
                        Deactivate Partner
                      </p>
                    );
                  else if (item.component === "ActivatePartner")
                    return (
                      <p
                        style={{
                          cursor: "pointer",
                          color: "#00b1b1",
                        }}
                        onClick={() => setActivatePartnerDrawer(true)}
                      >
                        Activate Partner
                      </p>
                    );
                  else if (item.component === "DeactivateUser")
                    return (
                      <p
                        style={{
                          cursor: "pointer",
                          color: "#00b1b1",
                        }}
                        onClick={() => setDeactivateUserDrawer(true)}
                      >
                        Deactivate User
                      </p>
                    );
                  else if (item.component === "ResendWelcomeMail")
                    return (
                      <p
                        style={{
                          cursor: "pointer",
                          color: "#00b1b1",
                        }}
                        onClick={() => setResendWelcomeMailDrawer(true)}
                      >
                        Resend Welcome Mail
                      </p>
                    );
                  else if (item.component === "ActivateUser")
                    return (
                      <p
                        style={{
                          cursor: "pointer",
                          color: "#00b1b1",
                        }}
                        onClick={() => setActivateUserDrawer(true)}
                      >
                        Activate User
                      </p>
                    );
                  else if (item.component === "ModifyBankDetails")
                    return (
                      <p
                        style={{
                          cursor: "pointer",
                          color: "#00b1b1",
                        }}
                        onClick={() => {
                          history(`/${redirectRoute}/modify-bank`, {
                            state: {
                              partnerFirmId: row?.original?.partnerFirmId,
                            },
                          });
                        }}
                        key={index}
                      >
                        Modify Bank Details
                      </p>
                    );
                  else if (item.component === "ViewUserEditDetails")
                    return (
                      <p
                        style={{
                          cursor: "pointer",
                          color: "#00b1b1",
                        }}
                        onClick={() => setViewUserEditDetailsDrawer(true)}
                      >
                        View/ Edit Detail
                      </p>
                    );
                  else if (
                    item.component === "IsPrimary" &&
                    !row?.original?.isPrimary
                  ) {
                    return (
                      <p
                        style={{
                          cursor: "pointer",
                          color: "#00b1b1",
                        }}
                        onClick={() => setMakePrimaryDrawer(true)}
                      >
                        Make Primary
                      </p>
                    );
                  } else if (
                    item.component === "IsPrimary" &&
                    row?.original?.isPrimary
                  ) {
                    const isSelf = row?.original?.emailAddress === isEmailMatch;

                    return (
                      <p
                        style={{
                          cursor: isSelf ? "not-allowed" : "pointer",
                          color: isSelf ? "#c8c8c8" : "#00b1b1",
                        }}
                        onClick={() => {
                          if (!isSelf) {
                            setRemovePrimaryDrawer(true);
                          }
                        }}
                      >
                        Remove Primary
                      </p>
                    );
                  } else if (item.component === "ViewPartnerUserEditDetails") {
                    const isPartner = row?.original?.roleType === "PARTNER";

                    return (
                      <p
                        style={{
                          cursor: isPartner ? "not-allowed" : "pointer",
                          color: isPartner ? "#c8c8c8" : "#00b1b1",
                        }}
                        onClick={() =>
                          !isPartner &&
                          setPartnerViewEditUserDetailsDrawer(true)
                        }
                      >
                        View/ Edit Detail
                      </p>
                    );
                  } else if (item.component === "ActivatePartnerUser")
                    return (
                      <p
                        style={{
                          cursor: "pointer",
                          color: "#00b1b1",
                        }}
                        onClick={() => setActivatePartnerUserDrawer(true)}
                      >
                        Activate Partner User
                      </p>
                    );
                  else if (item.component === "DeactivatePartnerUser") {
                    const isPartner = row?.original?.roleType === "PARTNER";
                    const isSelf = row?.original?.emailAddress === isEmailMatch;
                    const isDisabled = isPartner || isSelf;

                    return (
                      <p
                        style={{
                          cursor: isDisabled ? "not-allowed" : "pointer",
                          color: isDisabled ? "#c8c8c8" : "#00b1b1",
                        }}
                        onClick={() => {
                          if (!isDisabled) {
                            setDeactivatePartnerUserDrawer(true);
                          }
                        }}
                      >
                        Deactivate Partner User
                      </p>
                    );
                  } else if (item.component === "ResendPartnerWelcomeMail")
                    return (
                      <p
                        style={{
                          cursor: "pointer",
                          color: "#00b1b1",
                        }}
                        onClick={() => setResendPartnerWelcomeMailDrawer(true)}
                      >
                        Resend Welcome Mail
                      </p>
                    );
                  else if (item.component === "ViewEditDetails")
                    return (
                      <p
                        style={{
                          cursor: "pointer",
                          color: "#00b1b1",
                        }}
                        onClick={() => {
                          history(`/${redirectRoute}/edit-partner`, {
                            state: {
                              partnerFirmId: row?.original?.partnerFirmId,
                            },
                          });
                        }}
                        key={index}
                      >
                        View/Edit Details
                      </p>
                    );
                  else if (item.component === "ViewLeadDetails")
                    return (
                      <p
                        style={{
                          cursor: "pointer",
                          color: "#00b1b1",
                        }}
                        onClick={() => {
                          history(`/leadManagementDashboard/view-lead`, {
                            state: { leadId: row?.original?.leadId },
                          });
                        }}
                        key={index}
                      >
                        View Details
                      </p>
                    );
                  else if (item.component === "AddEditDocuments")
                    return (
                      <p
                        style={{
                          cursor: !partnerQualification
                            ? "not-allowed"
                            : "pointer",
                          color: !partnerQualification ? "#c8c8c8" : "#00b1b1",
                        }}
                        onClick={() => {
                          if (partnerQualification) {
                            history(`/leadManagementDashboard/view-leadDoc`, {
                              state: { leadId: row?.original?.leadId },
                            });
                          }
                        }}
                        key={index}
                      >
                        View/Edit Doc Details
                      </p>
                    );
                  else if (item.component === "EditDetails")
                    return (
                      <p
                        style={{
                          cursor: "pointer",
                          color: "#00b1b1",
                        }}
                        onClick={() => {
                          history(`/leadManagementDashboard/editLeadDoc`, {
                            state: { leadId: row?.original?.leadId },
                          });
                        }}
                      >
                        Edit Lead
                      </p>
                    );
                })}
            </div>
          </div>
        }
        trigger="click"
        onVisibleChange={(visible) => {
          if (visible) {
            handlePopoverOpen(row);
          }
        }}
      >
        ...
      </Popover>
    </div>
  );
}

export default PopoverMenuSolved;
